import { h, Component } from 'preact';
import util from 'preact-util';
import { observer } from 'mobx-preact';
import { Text, Localizer } from 'preact-i18n';
import Markdown from 'preact-markdown';
import { route } from 'preact-router';
import linkstate from 'linkstate';

import localUtil from '../../lib/util';

const categoryIcons = {
    'Smileys & Emotion': '😃',
    'People & Body':      '🧑‍🤝‍🧑',
    'Animals & Nature':   '🐾',
    'Food & Drink':       '🍔',
    'Travel & Places':    '✈️',
    'Activities':         '⚽',
    'Objects':            '💡',
    'Symbols':            '🔣',
    'Flags':              '🚩'
};

const emojisByCategory = {
    'Smileys & Emotion': [
        '😂','❤️','🤣','😊','😍','😢','😭','😉','😘','😋',
        '🤗','🤔','😎','🥰','🤩','😇','😏','😜','🤪','🤓',
        '🥳','🤯','😳','🤭','😬','😷','🤒','😴','🥺','😌',
    ],
    'People & Body': [
        '👍','👏','🙌','🙏','🤝','🤷','🤦','👋','🖐️','✋',
        '👌','✌️','🤞','👆','👇','👈','👉','🫰','🤟','🤘',
        '🤙','💪','🤲','👐','💁','🧏','🤰','🤸','🧘','🚶',
    ],
    'Animals & Nature': [
        '🐶','🐱','🐭','🐰','🐹','🦊','🐻','🐼','🐨','🐯',
        '🦁','🐮','🐷','🐸','🐵','🦄','🐔','🐧','🐦','🐤',
        '🐥','🦆','🦅','🦉','🦇','🐺','🐗','🐴','🦓','🦬',
    ],
    'Food & Drink': [
        '🍏','🍎','🍐','🍊','🍋','🍌','🍉','🍇','🍓','🍒',
        '🍑','🍍','🥭','🥑','🍅','🍆','🌽','🥕','🥦','🥔',
        '🍔','🍟','🌭','🍕','🥪','🌮','🌯','🍜','🍣','🍰',
    ],
    'Travel & Places': [
        '🚗','🚕','🚙','🚌','🚎','🏎️','🚓','🚑','🚒','🚐',
        '🚚','🚛','🚜','🛴','🚲','🛵','🏍️','🚂','🚃','🚄',
        '🚅','✈️','🚁','🚀','🚤','🛳️','⛴️','⛵','🏠','🏨',
    ],
    'Activities': [
        '⚽','🏀','🏈','⚾','🎾','🏐','🏉','🎱','🏓','🏸',
        '🥅','🏒','🏑','🥍','🏏','⛳','🏹','🎣','🤿','🏊',
        '🏄','🚣','🧗','🚵','🚴','🎿','⛷️','🏂','🪂','🏋️',
    ],
    'Objects': [
        '📱','💻','🖥️','⌨️','🖱️','🖨️','📷','📹','🎥','📺',
        '📻','🎙️','🎧','📞','☎️','🔑','💡','🔦','🕯️','🗑️',
        '🛒','🛍️','🎒','💼','🧳','🚪','🛏️','🛋️','⌚','📅',
    ],
    'Symbols': [
        '❤️','💔','💕','💖','✨','🌟','⭐','⚡','🔥','💥',
        '💫','✅','✔️','❌','❗','❓','⚠️','🔔','🎵','🎶',
        '💯','💲','©️','®️','™️','🔀','🔁','🔃','➡️','⬅️',
    ],
    'Flags': [
        '🇬🇧','🇨🇦','🇦🇺','🇫🇷','🇩🇪','🇮🇹','🇪🇸','🇯🇵','🇰🇷',
        '🇨🇳','🇮🇳','🇧🇷','🇲🇽','🇳🇴','🇸🇪','🇩🇰','🇫🇮','🇳🇱','🇧🇪',
        '🇨🇭','🇦🇹','🇷🇺','🇿🇦','🇲🇾','🇸🇬','🇹🇭','🇮🇩','🇻🇳','🇵🇭', '🇺🇸',
    ]
};

@observer
class EmojiPicker extends Component {
  	constructor(props) {
        super(props);
        this.state = {
            activeCategory: 'Smileys & Emotion',
        };
    }

    render() {
        const { addEmoji = () => {} } = this.props;
        const {
            activeCategory = 'Smileys & Emotion',
        } = this.state;

        return (<>
            <div class='d-flex flex-row flex-nowrap border-bottom'>
                <ul class='nav nav-pills p-1'>
                    {Object.keys(emojisByCategory).map(cat => (
                        <li class='nav-item' key={cat}>
                            <a
                                href='#'
                                class={`nav-link ${activeCategory === cat ? ' active' : ''} px-2`}
                                onClick={e => {
                                    e.preventDefault();
                                    this.setState({ activeCategory: cat });
                                }}
                            >
                                {categoryIcons[cat]}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
            <div class='d-flex flex-wrap border-bottom pb-3'>
                {emojisByCategory[activeCategory].map(emoji => (
                    <span
                        key={emoji}
                        class='emoji-item m-2'
                        onClick={() => addEmoji(emoji)}
                    >
                        {emoji}
                    </span>
                ))}
            </div>
            {/* <div class='d-flex flex-row flex-nowrap border-top'>
                <button
                    class='btn btn-link text-muted p-0'
                    onClick={this.addEmoji}
                >
                    <Text id='comment.addRandomEmoji'>Add a random emoji</Text>
                </button>
            </div> */}
        </>);
    }
}

export default EmojiPicker;
